import { Injectable } from "@angular/core";
import { Confirmation, ConfirmationService } from "primeng/api";
import { localize } from "@rinami/cc7-ng";

/**
 * Custom ConfirmationService that extends PrimeNG's ConfirmationService.
 *
 * Provides a single app-wide point for confirmation dialog defaults so every
 * component can call `confirm()` with only the values that differ per use-case.
 * Per-call properties always win — the spread order ensures nothing is silently
 * overridden.
 */
@Injectable({
  providedIn: "root",
})
export class CustomConfirmationService extends ConfirmationService {
  override confirm(confirmation: Confirmation): this {
    const defaults: Confirmation = {
      // Reset every option that the shared <p-confirmDialog> instance can retain
      // from a previous confirm() call, so each dialog starts from a known state.
      header: undefined,
      icon: undefined,
      acceptLabel: localize("common.ok"),
      rejectLabel: localize("common.cancel"),
      acceptVisible: true,
      rejectVisible: true,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-text",
      ...confirmation,
    };
    return super.confirm(defaults);
  }
}
